import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
 0% {
    background-position: -500px 0;
  }
  100% {
    background-position: 500px 0;
  }
`;

export const Skeleton = styled.div`
  background: linear-gradient(180deg, #1b1c1e 0%, #121314 100%);
  border: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.08) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: ${shimmer} ${({ $animationTime }) => `${$animationTime}s`} linear
      infinite forwards;
  }
`;
